// import { useLocation } from 'react-router-dom';
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, SCIENER_URL } from "../config/Urls";
import Storage from "../utils/HandelLocalStorage";
import { getHotelWiseToken, getToken } from "../utils/helper";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { routes } from "../shared/AppRouting";


const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 180000,
  params: {},
});

const sciener = axios.create({
  baseURL: SCIENER_URL,
  timeout: 18000,
  params: {},
});


let getPathRef: () => string = () => window.location.pathname;

// Add a request interceptor
instance.interceptors.request.use(
  async function (config: any) {
    try {
      const params = await getToken();
      // const data = JSON.parse(localStorage.getItem("userHotelsDetails")) || {};
      const dataToken = await getHotelWiseToken();

      
      let token = getPathRef() === "/owner-frame-report" ? dataToken : params; // Prioritize correctly
      const tokens = token; // Fetch token dynamically before each request
      if (tokens) {
        config.headers.Authorization = tokens;
      }
    } catch (error) {
      console.error("Error fetching token:", error);
    }
    return config;
  },
  function (error: any) {
    // return Promise.reject(error);
    console.log("error from interceptor request", error);
    return Promise.reject(error);
    // return error;
  }
);

// Add a response interceptor
export const setupInterceptors = (getPath: () => string) => {

  instance.interceptors.response.use(
    function (response: any) {
      // console.log('++++++++++Response Config++++++++++', response);
      return response;
    },
    async function (error: any) {
      console.log("error from interceptor response", error);
      if (error.response.status === 401) {

        Storage.clearItem("userDetails");
        Storage.clearItem("userOwnerDetails");
        Storage.clearItem("persist:root");
        Storage.clearItem("userHotelsDetails");
        Cookies.remove("authData");
        Cookies.remove("authHotelData");

        localStorage.removeItem("lng");
        const currentPath = getPath();

        if (routes?.find((item) => item?.path === currentPath)?.isPrivateRoute) {
          toast.error("Session expired. Please log in again.");
          window.location.href = "/login"; // Update with your login route
        }
        // toast.error(error.response.data.message);
        return error.response;
      } else {
        // toast.error(error.response.data.message);
        console.log('Error:', error.response.data.message);
      }

      return error.response;
      // if (error) return error;
    }
  );
}

export default instance;
